import { apiList, apiGet, apiCreate } from './apiClient';

export async function getCalls(params?: { property_id?: number | string; unit_id?: number | string; per_page?: number; page?: number }) {
  const qs: Record<string, string | number | boolean> = {};
  if (params?.property_id != null) qs.property_id = params.property_id;
  if (params?.unit_id != null) qs.unit_id = params.unit_id;
  if (params?.per_page != null) qs.limit = params.per_page;
  return apiList('call_history', Object.keys(qs).length ? qs : undefined);
}

export async function getCallById(id: number | string) {
  return apiGet('call_history', id);
}

export async function createCall(data: any) {
  return apiCreate('call_history', data);
}
